export const isIconOnLeft = (left: number): boolean => {
  const screenWidth = document.body.offsetWidth;
  const favoriteModalWidth = 470;
  return screenWidth - left >= favoriteModalWidth;
};
